import { combineReducers } from 'redux';
import UnitHome from './UnitHome';
import ItineraryIncident from './ItineraryIncident';
import Incident from './Incident';
import IncidentRecord from './IncidentRecord';
import AgencyIncident from './AgencyIncident';
import AdministrativeIncident from './AdministrativeIncident';

export default combineReducers({
  UnitHome,
  ItineraryIncident,
  Incident,
  IncidentRecord,
  AgencyIncident,
  AdministrativeIncident,
});
